import { HTMLInputTypeAttribute, useCallback } from 'react';
import { useField } from 'formik';
import TextInputControlled from '../TextInputControlled';

interface TextInputProps {
  name: string;
  label?: string;
  isLabelMultiline?: boolean;
  placeholder?: string;
  disabled?: boolean;
  type?: HTMLInputTypeAttribute;
  tooltip?: string;
  suffix?: string;
  min?: number;
  max?: number;
  step?: number;
  pulsateError?: boolean;
  required?: boolean;
}

function TextInput({ name, ...props }: TextInputProps) {
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField(
    name.toString(),
  );

  const onBlur = useCallback(() => setTouched(true), [setTouched]);

  return (
    <TextInputControlled
      {...props}
      id={name.toString()}
      value={value || ''}
      onChange={newValue => setValue(newValue)}
      onBlur={onBlur}
      isError={touched && !!error}
    />
  );
}

export default TextInput;
